// Hands the visitor's first name from the wizard to the menu page's thanks
// banner (#1221). sessionStorage rather than a query param, so no PII lands in
// URLs, analytics or referrers. Keyed by the event reference and short-lived;
// anything off (another tab, expired, storage blocked) falls back to "Thanks!".

const KEY = "tc_plan_handoff";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

interface Handoff {
  ref: string;
  firstName: string;
  at: number;
}

export function savePlanHandoff({ ref, firstName }: { ref: string; firstName: string }): void {
  try {
    const entry: Handoff = { ref, firstName, at: Date.now() };
    window.sessionStorage.setItem(KEY, JSON.stringify(entry));
  } catch {
    // Storage blocked (private mode, quota): the banner just says "Thanks!".
  }
}

/** The first name saved for `ref`, or null. */
export function readPlanHandoff(ref: string | null): string | null {
  if (!ref) return null;
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const entry = JSON.parse(raw) as Partial<Handoff>;
    if (entry.ref !== ref || typeof entry.at !== "number" || Date.now() - entry.at > MAX_AGE_MS) return null;
    return typeof entry.firstName === "string" && entry.firstName ? entry.firstName : null;
  } catch {
    return null;
  }
}
